import { render, staticRenderFns } from "./RecentOrderReorder.vue?vue&type=template&id=3ec53c9f&scoped=true&"
import script from "./RecentOrderReorder.vue?vue&type=script&lang=js&"
export * from "./RecentOrderReorder.vue?vue&type=script&lang=js&"
import style0 from "./RecentOrderReorder.vue?vue&type=style&index=0&id=3ec53c9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec53c9f",
  null
  
)

export default component.exports